import * as React from 'react';
import {FunctionComponent} from 'react';
import {Curve} from '../../../../../../Models/Curve';
import {CurveGraph} from '../../../../Charts/CurveGraph';
import {TopRow} from './TopRow';
import {DataRows} from './DataRows';

interface OwnProps {
    topBuckets: Array<{
        value: {formatted: string; unit?: string};
        label: string;
    }>;
    dataBuckets: Array<{
        value: {formatted: string; unit?: string};
        label: string;
    }>;
    curve: Curve;
    referenceCurve?: Curve;
}

export const Content: FunctionComponent<OwnProps> = ({topBuckets, dataBuckets, curve, referenceCurve}) => {
    return (
        <>
            <div className="row mb-3">
                <div className="col-12 d-flex gap-3 flex-row flex-wrap">
                    <TopRow buckets={topBuckets} />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-lg-6">
                    <CurveGraph curve={curve} referenceCurve={referenceCurve} />
                </div>
                <div className="col-12 col-lg-6 d-flex flex-row flex-wrap gap-3 align-content-center">
                    <DataRows buckets={dataBuckets} />
                </div>
            </div>
        </>
    );
};
